import { WhatsAppButtonDefinition, WhatsAppHeaderDefinition } from 'modules/graphql';
import { PreviewWithDataErrorMessage } from 'modules/templateEditor/common';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface WhatsAppPreviewContextState {
  whatsAppHeader?: WhatsAppHeaderDefinition;
  whatsAppMessage?: string;
  whatsAppButtons?: WhatsAppButtonDefinition[];
  isLoading: boolean;
  hasContent: boolean;
  hasLoadedData: boolean;
  previewError?: PreviewWithDataErrorMessage;
  onRefreshPreview: () => void;
}

export const WhatsAppPreviewContext = createContext<WhatsAppPreviewContextState>({
  whatsAppHeader: undefined,
  whatsAppMessage: undefined,
  whatsAppButtons: undefined,
  isLoading: false,
  hasContent: false,
  hasLoadedData: false,
  previewError: undefined,
  onRefreshPreview: noop,
});

export const useWhatsAppPreviewContext = () => useContext(WhatsAppPreviewContext);
